module.exports = __webpack_public_path__ + "static/media/marketing-website.839c6ef4.svg";